import Signup from '../views/Signup'

export default {
  path: '/signup',
  name: 'signup',
  component: Signup
}
